import React from "react";
import { colors } from '../../../theme/colors';
import { primaryContainedButtonSx } from '../../../theme/buttonStyles';
import {
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  Chip,
  CircularProgress,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CodeIcon from "@mui/icons-material/Code";
import logo from "../../../assets/Images/element-wordmark-dark.svg";
import { StartPageWrapper } from "./style";

const GUIDELINES = [
  "You will have 60 minutes to solve 6 coding questions.",
  "Your webcam will be on throughout the test for face verification.",
  "Do not switch tabs or exit fullscreen — 3 violations will cancel your test.",
  "Copy/paste is disabled inside the code editor.",
  "Save your progress on each question before navigating.",
  "You can move between questions freely using the sidebar.",
  "The test auto-submits when time runs out.",
];

const StartAssessmentPage = ({
  interviewDetail,
  agreed,
  setAgreed,
  canStartInterview,
  countdownText,
  onStart,
  interviewStatus,
}) => {
  if (interviewStatus === "loading") {
    return (
      <StartPageWrapper>
        <Box className="start-header">
          <img src={logo} alt="Berlin" />
          <Typography className="header-text">Technical Assessment</Typography>
        </Box>
        <Box className="start-body">
          <CircularProgress sx={{ color: colors.primary }} />
        </Box>
      </StartPageWrapper>
    );
  }

  return (
    <StartPageWrapper>
      <Box className="start-header">
        <img src={logo} alt="Berlin" />
        <Typography className="header-text">Technical Assessment</Typography>
      </Box>

      <Box className="start-body">
        <Box className="start-card">
          <Typography className="start-title">
            Welcome, {interviewDetail?.candidateName || "Candidate"}
          </Typography>
          <Typography className="start-subtitle">
            Coding Assessment for{" "}
            <strong>{interviewDetail?.applyFor || "the position"}</strong>
          </Typography>

          <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
            <Chip
              icon={<CodeIcon sx={{ fontSize: 16 }} />}
              label="6 Questions"
              size="small"
              sx={{ backgroundColor: colors.sidebarSelected, color: colors.primary, fontWeight: 600 }}
            />
            <Chip
              icon={<AccessTimeIcon sx={{ fontSize: 16 }} />}
              label="60 Minutes"
              size="small"
              sx={{ backgroundColor: "#fff3e0", color: "#e65100", fontWeight: 600 }}
            />
          </Box>

          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#1d2939", mb: 1 }}>
            Guidelines
          </Typography>
          <ol className="guidelines-list">
            {GUIDELINES.map((g, i) => (
              <li key={i}>{g}</li>
            ))}
          </ol>

          {countdownText && (
            <Box className="countdown-box">
              <AccessTimeIcon sx={{ color: colors.primary }} />
              <Box>
                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: colors.primary }}>
                  {countdownText}
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#667085" }}>
                  Please wait for the assessment window to open.
                </Typography>
              </Box>
            </Box>
          )}

          <FormControlLabel
            className="agree-row"
            control={
              <Checkbox
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                disabled={!canStartInterview}
                sx={{
                  color: colors.primary,
                  "&.Mui-checked": { color: colors.primary },
                }}
              />
            }
            label={
              <Typography sx={{ fontSize: "14px", color: "#344054" }}>
                I have read and agree to the guidelines above.
              </Typography>
            }
          />

          <Button
            variant="contained"
            fullWidth
            disabled={!agreed || !canStartInterview}
            onClick={onStart}
            sx={{
              ...primaryContainedButtonSx,
              borderRadius: "12px",
              py: 1.5,
              fontSize: "16px",
              fontWeight: 600,
            }}
          >
            Start Assessment
          </Button>
        </Box>
      </Box>
    </StartPageWrapper>
  );
};

export default StartAssessmentPage;
